<br *ngIf="breakLineBefore" />
<span *ngIf="value">
  <span [innerHTML]="label"></span>
  &nbsp;
  <br *ngIf="breakLine" />
  <b [innerHTML]="value"></b>
</span>
